<template>
  <router-view />
</template>

<script>
import vanModule from '../../store/vans'

export default {
  beforeCreate () {
    this.$store.registerModule('vans', vanModule)
  },
  destroyed () {
    this.$store.unregisterModule('vans')
  }
}
</script>
